import Paragraph, { TextColour } from './Paragraph';

export { Paragraph, TextColour };
